import DetallePeriodo from 'containers/Admin/Periodo'

export default function Periodo() {
  return (
    <DetallePeriodo />
  );
}
